// TEMPLATE — pending licensed attorney review (insurance + financial services).
// Do not treat the seeded copy as final legal text.
import { createFileRoute } from "@tanstack/react-router";
import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/privacy")({
  head: () =>
    seo({
      title: "Privacy Policy · Currency Thoughts",
      description:
        "How Currency Thoughts LLC collects, uses, and protects your personal information.",
      canonical: "/privacy",
    }),
  component: () => (
    <LegalPageLayout
      slug="privacy"
      fallbackTitle="Privacy Policy"
      fallbackHeadline="How we protect your information."
    />
  ),
});